import { useTranslation } from 'react-i18next'

export function PlanReasons({ reasons = [], findings = [] }) {
  const { t } = useTranslation()
  if (reasons.length === 0) return null
  const byCode = Object.fromEntries(findings.map((f) => [f.code, f]))

  return (
    <section aria-labelledby="ai-plan-reasons">
      <h3 id="ai-plan-reasons" className="text-sm font-semibold text-gray-900 mb-2">{t('aiPlan.review.reasons')}</h3>
      <ul className="space-y-1 text-sm">
        {reasons.map((reason, i) => {
          const finding = byCode[reason.finding_code]
          return (
            <li key={`${reason.finding_code}-${i}`} className="text-gray-700">
              {reason.exercise_name && <span className="font-medium">{reason.exercise_name}: </span>}
              {reason.change}
              <span className="ml-2 inline-block rounded bg-gray-100 px-1.5 text-xs text-gray-600">
                {t('aiPlan.review.finding')}: {finding?.subject ? `${finding.subject} · ` : ''}{reason.finding_code}
              </span>
            </li>
          )
        })}
      </ul>
    </section>
  )
}
